/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IdentityProviderClaimMatchRule { 
    /**
     * Mapping claim type.
     */
    claimType: string;
    /**
     * Logical operator.
     */
    operator: IdentityProviderClaimMatchRuleOperator;
    /**
     * Mapping claim value.
     */
    value: string;
    /**
     * Indicates whether value comparison must be case sensitive.
     */
    matchCase: boolean;
}
export enum IdentityProviderClaimMatchRuleOperator {
    Unknown = 'Unknown',
    Equals = 'Equals',
    NotEquals = 'NotEquals',
    Contains = 'Contains',
    NotContains = 'NotContains',
    MatchRegex = 'MatchRegex'
};



